/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import FiduciaPdf from '../components/FiduciaPdfComponents';
import PdfBody from '../PdfBody';
import { IFaresAppSheet } from './interface';

export class DownloadPdf extends React.Component<IFaresAppSheet> {
  render() {
    return (
      <FiduciaPdf.Page>
        <FiduciaPdf.Header>
          <FiduciaPdf.Logo />
          <FiduciaPdf.MainTitle>Relatório de Tarifas</FiduciaPdf.MainTitle>
        </FiduciaPdf.Header>
        <FiduciaPdf.Body>
          <PdfBody
            body={this.props.body}
            title={this.props.title}
            isLastTwelveMonths={this.props.isLastTwelveMonths}
          />
        </FiduciaPdf.Body>
      </FiduciaPdf.Page>
    );
  }
}

export default DownloadPdf;
